<template>
  <div class="MallDemo">
    <div class="order-item-title">表单详情</div>
    <div class="boxShadow" @click="jump">
      <img :src="makeThumb">
      <div class="title">
        <h4 class="textOver">{{ info.productName }}</h4>
        <p class="price">￥{{ info.price / 100 | PriceFilter}} </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return{
      thumb: {},
    }
  },
  props: {
    info: {
      type: Object,
      default () {
        return{};
      },
    }
  },
  methods:{
    jump() {
      this.$router.push({ path: `/shoppingMall/ProductDetalis` , query: { id: this.info.productId } });
    },
  },
  computed: {
    makeThumb() {
      return this.info.thumb && this.info.thumb.length ? this.info.thumb[0].img : '';
    },
  },
}
</script>
<style lang="scss" scoped>
.boxShadow{
  width: 285px;
  height: 343px;
  cursor: pointer;
  .title {
    padding: 0 20px;
  }
  h4 {
    width: 100%;
    height: 24px;
    overflow: hidden;
    font-size: 18px;
    font-weight: 600;
  }
  .price {
    font-size: 20px;
    color: #de2c32;
  }
  img {
    width: 100%;
    height: 285px;
    border-radius: 4px 4px 0 0;
  }
  &:last-of-type {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orderDetails/MallDemo.vue